import React, { ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { Text } from '@components/Text/Text.component';
import classnames from 'classnames';

interface Props extends ComponentPropsWithRef<'div'> {
  i18nTitle: string;
  type: 'favorite' | 'accordion' | 'journal';
  unit?: string;
}

function buildOptions(
  type: Props['type']
): {
  title: ComponentPropsWithRef<typeof Text>;
  amount: ComponentPropsWithRef<typeof Text>;
  unit: ComponentPropsWithRef<typeof Text>;
} {
  switch (type) {
    case 'favorite': {
      return {
        amount: { variant: 'new-bold-p' },
        title: { flavour: 'meteo-dark-green', variant: 'tiny-title' },
        unit: { flavour: 'black', variant: 'new-bold-p' },
      };
    }
    case 'accordion': {
      return {
        amount: { variant: 'h6' },
        title: { style: { fontWeight: 400 }, variant: 'h6' },
        unit: { variant: 'h6' },
      };
    }
    case 'journal': {
      return {
        amount: { variant: 'h4' },
        title: { flavour: 'grey', variant: 'tiny-title' },
        unit: { flavour: 'grey', variant: 'tiny-title' },
      };
    }
    default: {
      const testSwitch: never = type;
      return testSwitch;
    }
  }
}

export const StockInfo: FC<PropsWithChildren<Props>> = ({ i18nTitle, type, children, className, unit, ...rest }) => {
  const rootClassName = classnames('inline-flex', 'column', 'white-space-nowrap', className);
  const options = buildOptions(type);
  return (
    <div className={rootClassName} {...rest}>
      <Text {...options.title} i18nKey={i18nTitle} />
      {children && (
        <Text tag="div" {...options.amount}>
          {children}
          {unit && <Text tag="span" {...options.unit}>{` ${unit}`}</Text>}
        </Text>
      )}
    </div>
  );
};
